<template>
  <div class="tour-info-box">
    <component :is="icon" class="icon" />
    <div class="tour-info-box__info">
      <h6 class="tour-info-box__info--title font-14">{{ title }}</h6>
      <span class="tour-info-box__info--text font-12">{{ text }}</span>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'InfoBox',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: Object,
      required: true,
    },
  },
});
</script>
<style lang="scss">
.tour-info-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;

  .icon {
  }
  &__info {
    width: 90%;

    &--text {
      font-size: 12px;
    }
  }
}
</style>
